module.exports = "https://web-assets-production.autolist.com/_next/static/images/convertible-d785b54e291983ddddb5cc9a77b097ea.jpg";